import { injectTheme } from "./theme.js";

const STYLE_ID = "ghostland-toast-style";

const CSS = `
#gl-toast {
  position: fixed; left: 50%; bottom: 84px; transform: translateX(-50%) translateY(8px);
  z-index: 40; padding: 9px 16px;
  background: var(--gl-panel); border: 1px solid var(--gl-border); border-radius: 8px;
  color: var(--gl-text); font-family: ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 12px; box-shadow: 0 8px 24px rgba(0,0,0,.6);
  opacity: 0; pointer-events: none; transition: opacity .15s, transform .15s;
}
#gl-toast.show { opacity: 1; transform: translateX(-50%) translateY(0); }

/* Big centred banner for headline moments (e.g. winning a poker hand). */
#gl-banner {
  position: fixed; left: 50%; top: 34%; transform: translate(-50%, -50%) scale(.8);
  z-index: 60; padding: 22px 46px; max-width: 86vw;
  background: linear-gradient(180deg, rgba(22,13,30,.96), rgba(8,4,12,.96));
  border: 3px solid var(--gl-accent, #ffd23f); border-radius: 16px;
  color: #fff; font-family: ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: clamp(22px, 4vw, 36px); font-weight: 800; letter-spacing: 1px; text-align: center; white-space: pre-line; line-height: 1.25;
  text-shadow: 0 2px 8px rgba(0,0,0,.85);
  box-shadow: 0 0 0 2px rgba(0,0,0,.5), 0 18px 54px rgba(0,0,0,.7), 0 0 46px rgba(255,210,63,.4);
  opacity: 0; pointer-events: none; transition: opacity .25s, transform .3s cubic-bezier(.2,1.5,.4,1);
}
#gl-banner.show { opacity: 1; transform: translate(-50%, -50%) scale(1); }
`;

function ensureStyle(): void {
  injectTheme();
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = CSS;
  document.head.appendChild(style);
}

let hideTimer: number | undefined;

/** Show a transient bottom toast message (e.g. "Inventory full"). */
export function showToast(message: string, ms = 2000): void {
  ensureStyle();
  let el = document.getElementById("gl-toast");
  if (!el) {
    el = document.createElement("div");
    el.id = "gl-toast";
    document.body.appendChild(el);
  }
  el.textContent = message;
  // Force reflow so the transition replays even on rapid repeats.
  void el.offsetWidth;
  el.classList.add("show");
  if (hideTimer !== undefined) window.clearTimeout(hideTimer);
  hideTimer = window.setTimeout(() => el!.classList.remove("show"), ms);
}

let bannerTimer: number | undefined;

/** Show a BIG centred banner for a headline moment (e.g. "You won the hand"). `extra` nodes (e.g. the
 *  winner's hole-card canvases) render INSIDE the same panel, in a row below the message text. */
export function showBanner(message: string, ms = 3800, extra?: HTMLElement[]): void {
  ensureStyle();
  let el = document.getElementById("gl-banner");
  if (!el) {
    el = document.createElement("div");
    el.id = "gl-banner";
    document.body.appendChild(el);
  }
  el.textContent = ""; // rebuild contents (message + optional card row)
  const msg = document.createElement("div");
  msg.textContent = message;
  el.appendChild(msg);
  if (extra && extra.length) {
    const row = document.createElement("div");
    row.style.cssText = "display:flex;gap:10px;justify-content:center;margin-top:16px;";
    for (const node of extra) row.appendChild(node);
    el.appendChild(row);
  }
  void el.offsetWidth;
  el.classList.add("show");
  if (bannerTimer !== undefined) window.clearTimeout(bannerTimer);
  bannerTimer = window.setTimeout(() => el!.classList.remove("show"), ms);
}
